exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navbar-title {\n  color: #ecf0f5;\n  display: inline;\n  margin-left: 50px;\n  font-size: 28px;\n  line-height: unset;\n}\n.img-circle,\n.user-image {\n  background-color: #fff;\n}\n", ""]);

// exports
